import http from "./api";
import Vue from "vue";
export default {
  // 密码登录
  getPassLogin(params) {
    return http.postJson(Vue, "/xxx-user/pc/normal/login", params);
  },
  // 验证码登录
  getCodeLogin(params) {
    return http.postJson(Vue, "/xxx-user/pc/sms/login", params);
  },
  // 注册
  registerAccount(params) {
    return http.postJson(Vue, "/xxx-user/pc/signup", params);
  },
  // 忘记密码
  changePwd(params, data) {
    return http.postJson(Vue, "/xxx-user/pc/pass/find", params, data);
  },
  // 校验手机账户是否存在
  getCheckAcc(params) {
    return http.get(Vue, "/xxx-user/checkAcc", params);
  },

  // 退出登录
  logout() {
    return http.get(Vue, "/xxx-user/pc/logout");
  }
};



// WEBPACK FOOTER //
// ./src/api/login.js